import axios from '../lib/axios';

export const createActivity = async (activityData) => {
    const { data } = await axios.post('/api/activities', activityData);
    return data;
};

export const updateActivity = async ({ id, ...activityData }) => {
    const { data } = await axios.put(`/api/activities/${id}`, activityData);
    return data;
};

export const completeActivity = async (id) => {
    const { data } = await axios.patch(`/api/activities/${id}/complete`);
    return data;
};

export const deleteActivity = async (id) => {
    const { data } = await axios.delete(`/api/activities/${id}`);
    return data;
};
